import { Box, Stack, Typography, Dialog } from "@mui/material"
import { styled } from "@mui/material/styles"
import type { FC } from ".."
import filmFestivalGlobals from "./assets/filmFestivalGlobals.json"
import { Transition, CloseButton } from "./JudgesSection"

type ErrorModalProps = {
  open: boolean
  onClose: () => void
  variant: "submittionLimit" | "generalError"
}

const ErrorModal: FC<ErrorModalProps> = ({ open, onClose, variant }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      sx={(theme) => ({
        "& .MuiDialog-paper": {
          backgroundColor: theme.palette["tertiary.800"].main,
          borderRadius: { xs: theme.spacing(2), md: theme.spacing(6) },
          maxWidth: 590,
        },
      })}
    >
      <Box position="relative" padding={{ xs: 8, md: 12.5 }}>
        <Content variant={variant} />
        <CloseButton handleClose={onClose} />
      </Box>
    </Dialog>
  )
}

export default ErrorModal

// A sub component for the confirmation modal content
const Content: FC<{ variant: "submittionLimit" | "generalError" }> = ({ variant }) => {
  const { errorModal } = filmFestivalGlobals
  const globals =
    variant === "submittionLimit" ? errorModal.submittionLimit : errorModal.generalError

  return (
    <Stack>
      <Stack gap={12}>
        <Typography
          variant="heading.md"
          sx={(theme) => ({
            color: theme.palette["primary.800"].main,
            fontWeight: 700,
            lineHeight: "90%!important",
            fontSize: "48px!important",
            [theme.breakpoints.down("md")]: {
              marginBottom: 8,
            },
          })}
        >
          {globals.title}
        </Typography>
        <Stack
          sx={(theme) => ({
            "& span": {
              color: theme.palette["neutral.800"].main,
              fontSize: "18px!important",
              fontWeight: 600,
              letterSpacing: "-0.096px",
              lineHeight: "130%",
            },
          })}
        >
          <Typography variant="body.md" mb={4}>
            {globals.description1}
          </Typography>
          <Box>
            <Typography variant="body.md" sx={(theme) => ({})}>
              {globals.description2}
              <StyledLink href={globals.redirectUrl} target="_blank">
                {globals.highlightedText}
              </StyledLink>
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}

const StyledLink = styled("a")(({ theme }) => ({
  color: theme.palette["primary.800"].main,
  fontWeight: 600,
  fontSize: "18px!important",
  lineHeight: "150%",
  textDecoration: "none",
  paddingLeft: 5,
}))
